import {ImgS} from "ui-seeker/core";
import * as React from "react";
import {IMAGE} from "../../../../../../@common/constants";

export default function SavedFiltersEmptyTableBlock() {
    return <div style={{ display: 'flex', alignContent: 'center', flexWrap: 'wrap' }}>
        <ImgS className="image-no-data-bounce" style={{ height: '200px', opacity: 0.5 }} src={`${IMAGE.ASSETS}/no-data-laptop.svg`} alt="No data available" />
        <div className="text-no-results">No Dashboards in this section</div>
    </div>
}